import React from 'react'
import { AddProduct, AddService} from "../../components/index"


const Admin = () => {
  return (
    <>

   <div>
<AddService/>
<AddProduct/>

   </div>
    
    </>
  )
}

export default Admin
